import React from "react";
import { Navigation, Autoplay, FreeMode, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/free-mode";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { useGetActiveBannersQuery } from "../../Redux/getApi";

const Banner = () => {
  const { data, error, isLoading, isFetching } = useGetActiveBannersQuery();
  const loading = [1, 2, 3, 4, 5, 6, 7];
  return (
    <div>
      <div className="w-[100%]  ">
        <Swiper
          modules={[Navigation, Autoplay, FreeMode, Pagination]}
          navigation={false}
          speed={1000}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            stopOnLastSlide: false,
          }}
          pagination={{ clickable: true }}
          loop={true}
          className="custom-swiper"
        >
          {isLoading || isFetching
            ? loading.map((i) => (
                <SwiperSlide
                  key={i}
                  className="flex justify-center w-full xl:px-[5%] lg:px-[3%] px-[2%] lg:py-6 py-4"
                >
                  <div className="bg-gray-200 animate-pulse aspect-[2.48/1] w-full md:rounded-2xl rounded-xl" />
                </SwiperSlide>
              ))
            : data?.banners?.map((banner, i) => (
                <SwiperSlide key={i}>
                  <div className="flex justify-center xl:px-[5%] lg:px-[3%] px-[2%] lg:py-6 py-4">
                    <div className="w-full relative">
                      <img
                        src={banner.imageUrl}
                        alt={`Banner ${i + 1}`}
                        className="w-full md:rounded-2xl rounded-xl "
                      />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
        </Swiper>
      </div>

      {error && (
        <div className="flex justify-center xl:px-[5%] lg:px-[3%] px-[2%] lg:py-6 py-4">
          <p className="bg-gray-200 animate-pulse aspect-[2.48/1]  w-full md:rounded-2xl rounded-xl  ">
            {error?.data?.error || error?.data?.message}
          </p>
        </div>
      )}
    </div>
  );
};

export default Banner;
